/**
 * Obviously :-)
 */
import Vue from 'vue'
import router from './router'
import store from './store'
import App from './App.vue'

/**
 * Load form stuff
 */
import BootstrapVue from 'bootstrap-vue'

/**
 * load fontawesome
 */
import { library as FontAwesomeLibrary } from '@fortawesome/fontawesome-svg-core'

import {
  faAngleRight,
  faArrowAltCircleRight,
  faArrowLeft,
  faArrowRight,
  faBackward,
  faBalanceScaleRight,
  faBracketsCurly,
  faCalendar,
  faCalendarCheck,
  faCheck,
  faCheckCircle,
  faCircleMinus,
  faCirclePlus,
  faCog,
  faCreditCard,
  faEdit,
  faExclamationCircle,
  faExclamationTriangle,
  faExternalLinkAlt,
  faFile,
  faFileDownload,
  faFileInvoiceDollar,
  faHandHoldingUsd,
  faHome,
  faLifeRing,
  faList,
  faPlus,
  faPowerOff,
  faRocket,
  faSave,
  faSearch,
  faSort,
  faSortDown,
  faSortUp,
  faSpinner,
  faSync,
  faTimes,
  faToggleOff,
  faToggleOn,
  faTrash,
  faUser,
  faUserAstronaut,
  faUsers,
  faUserSlash
} from '@fortawesome/pro-light-svg-icons'

import { faJoomla, faWordpress, faWordpressSimple } from '@fortawesome/free-brands-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

/**
 * load vue-snotify
 */
import Snotify, { SnotifyPosition } from 'vue-snotify'

/**
 * load chart lib
 */
import VueFrappe from 'vue2-frappe'

// Locals translation imports
import VueI18n from 'vue-i18n'
import locales from '../locales/locales'

// API
import axios from 'axios'
import VueAxios from 'vue-axios'

import { API_URL, ECHOSERVER } from '@/common/config'

// import { API_URL, ECHOSERVER, SENTRY_DSN } from '@/common/config'
// import * as Sentry from '@sentry/vue'
// import { Integrations } from '@sentry/tracing'
// Kekse, Kekse, Kekse
import Cookies from 'js-cookie'

// Notifications
import VueEcho from 'vue-echo-laravel'

// Highlighting
import VueHighlightJS from '@/services/highlighter'

window.io = require('socket.io-client')

/**
 * Load Styles
 */
require('./assets/sass/app.scss')

FontAwesomeLibrary.add(faCheckCircle)
FontAwesomeLibrary.add(faExclamationTriangle)
FontAwesomeLibrary.add(faCheck)
FontAwesomeLibrary.add(faSpinner)
FontAwesomeLibrary.add(faUser)
FontAwesomeLibrary.add(faCreditCard)
FontAwesomeLibrary.add(faFile)
FontAwesomeLibrary.add(faArrowAltCircleRight)
FontAwesomeLibrary.add(faToggleOn)
FontAwesomeLibrary.add(faToggleOff)
FontAwesomeLibrary.add(faHome)
FontAwesomeLibrary.add(faArrowRight)
FontAwesomeLibrary.add(faRocket)
FontAwesomeLibrary.add(faList)
FontAwesomeLibrary.add(faEdit)
FontAwesomeLibrary.add(faSearch)
FontAwesomeLibrary.add(faSort)
FontAwesomeLibrary.add(faSortDown)
FontAwesomeLibrary.add(faSortUp)
FontAwesomeLibrary.add(faArrowLeft)
FontAwesomeLibrary.add(faSave)
FontAwesomeLibrary.add(faSync)
FontAwesomeLibrary.add(faTrash)
FontAwesomeLibrary.add(faExternalLinkAlt)
FontAwesomeLibrary.add(faAngleRight)
FontAwesomeLibrary.add(faTimes)
FontAwesomeLibrary.add(faCog)
FontAwesomeLibrary.add(faBackward)
FontAwesomeLibrary.add(faPowerOff)
FontAwesomeLibrary.add(faJoomla)
FontAwesomeLibrary.add(faWordpressSimple)
FontAwesomeLibrary.add(faWordpress)
FontAwesomeLibrary.add(faFileDownload)
FontAwesomeLibrary.add(faUsers)
FontAwesomeLibrary.add(faFileInvoiceDollar)
FontAwesomeLibrary.add(faUserAstronaut)
FontAwesomeLibrary.add(faLifeRing)
FontAwesomeLibrary.add(faBalanceScaleRight)
FontAwesomeLibrary.add(faExclamationCircle)
FontAwesomeLibrary.add(faHandHoldingUsd)
FontAwesomeLibrary.add(faBracketsCurly)
FontAwesomeLibrary.add(faUserSlash)
FontAwesomeLibrary.add(faPlus)
FontAwesomeLibrary.add(faCirclePlus)
FontAwesomeLibrary.add(faCircleMinus)
FontAwesomeLibrary.add(faCalendarCheck)
FontAwesomeLibrary.add(faCalendar)

// Configure vue
Vue.config.productionTip = false

// Bootstrap
Vue.use(BootstrapVue)

Vue.component('font-awesome-icon', FontAwesomeIcon)

// Notifications
Vue.use(Snotify, {
  toast: {
    position: SnotifyPosition.rightBottom
  }
})

// Echo
require('pusher-js')

Vue.use(VueEcho, {
  broadcaster: 'socket.io',
  host: ECHOSERVER,
  authEndpoint: `${API_URL}api/broadcasting/auth`
})

// Charts
Vue.use(VueFrappe)

// i18n
Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: 'en',
  messages: locales
})

// Sentry
// Sentry.init({
//   Vue,
//   dsn: SENTRY_DSN,
//   integrations: [
//     new Integrations.BrowserTracing({
//       routingInstrumentation: Sentry.vueRouterInstrumentation(router),
//       tracingOrigins: ['localhost', ECHOSERVER, /^\//]
//     })
//   ],
//   // Set tracesSampleRate to 1.0 to capture 100%
//   // of transactions for performance monitoring.
//   // We recommend adjusting this value in production
//   tracesSampleRate: 1.0
// })

// Axios
Vue.use(VueAxios, axios)
Vue.axios.defaults.baseURL = API_URL

Vue.use(VueHighlightJS)

// Add a request interceptor
Vue.axios.interceptors.request.use(function (config) {
  const token = Cookies.get('bm-token')
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`
  }
  return config
}, function (error) {
  // Do something with request error
  return Promise.reject(error)
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
  created () {
    this.$store.commit('local/initialiseStore')
  }
}).$mount('#app')
